S.bulletContent =
    {
        config: {
        },

        elements: {
            $close: null,
        },

        init($module, config)
        {
            if (sessionStorage['bullet'])
            {
                this.$module.find('.m-wrapper').hide();
            }
            else
            {
                this.$module.find('.m-wrapper').show();
            }


            this.closeLayer(config);
        },

        closeLayer(config)
        {
            console.log(this.elements.$close);
            this.elements.$close.on('click', () =>
            {
                sessionStorage['bullet'] = true;
                this.$module.fadeOut();
            });
        },
    };









